import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
} from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { BaseModule } from 'shared/base/base.module'
import { BannerType } from 'shared/base/ht-banner/ht-banner.model'
import { dismissAnnouncementBanner } from '../../actions/user-settings.actions'
import { AnalyticsEvents } from '../../constants/analytics'
import { ADDONS_ANNOUNCEMENT_BANNER } from '../../constants/announcement-banners'
import * as fromRoot from '../../reducers'
import { Analytics } from '../../utils/analytics'

@Component({
  selector: 'app-addons-announcement-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseModule],
  templateUrl: './addons-announcement-banner.component.html',
  styleUrl: './addons-announcement-banner.component.scss',
})
export class AddonsAnnouncementBannerComponent {
  readonly #store = inject(Store)
  readonly #router = inject(Router)

  readonly bannerType = BannerType.Announcement

  readonly shouldShowBanner = computed(
    () =>
      !!this.me()?.is_admin &&
      this.dismissedVersion() !== ADDONS_ANNOUNCEMENT_BANNER.version
  )

  private readonly me = toSignal(this.#store.select(fromRoot.getMeState))
  private readonly dismissedVersion = toSignal(
    this.#store.select(
      fromRoot.getDismissedAnnouncementBannerVersion(
        ADDONS_ANNOUNCEMENT_BANNER.key
      )
    )
  )

  private hasTrackedView = false

  constructor() {
    // Track the banner impression once it becomes visible to an admin.
    effect(() => {
      if (!this.shouldShowBanner() || this.hasTrackedView) return
      this.hasTrackedView = true
      Analytics.event(AnalyticsEvents.ADDONS_ANNOUNCEMENT_BANNER_VIEWED, {
        version: ADDONS_ANNOUNCEMENT_BANNER.version,
      })
    })
  }

  onBannerClosed() {
    this.dismiss()
    Analytics.event(AnalyticsEvents.ADDONS_ANNOUNCEMENT_BANNER_DISMISSED, {
      version: ADDONS_ANNOUNCEMENT_BANNER.version,
    })
  }

  onExploreClick() {
    Analytics.event(
      AnalyticsEvents.ADDONS_ANNOUNCEMENT_BANNER_EXPLORE_CLICKED,
      {
        version: ADDONS_ANNOUNCEMENT_BANNER.version,
      }
    )
    this.dismiss()
    this.#router.navigate(['/addons'])
  }

  private dismiss() {
    this.#store.dispatch(
      dismissAnnouncementBanner({
        key: ADDONS_ANNOUNCEMENT_BANNER.key,
        version: ADDONS_ANNOUNCEMENT_BANNER.version,
      })
    )
  }
}
